export default __webpack_public_path__ + "static/store-preview-6a09b6a1622baba6d926217b2186f3c8.jpg";